export default {
  pageTitle: '资金户',
  hasBindAcc: '当前店铺已绑定资金户',
  accUserId: '资金户编号',
  accSubUserId: '结算子户编号',
  accList: '账户列表',
  balance: '可用金额',
  notAmount: '冻结金额',
  accOpenType: '选择资金户开户方式',
  bindOtherAcc: '绑定到已开通的其他资金户',
  openNewAcc: '开通新的资金户',
  confirm: '确认',
  accountType256: '现金账户',
  accountType512: '信用账户',
  accountType513: '分期账户',
  accountType1280: '积分账户',
  accountType144: '结算户',
  accountType128: '头程充值户',
  accountType110: '保证金账户',

  // dialog apply
  applyTitle: '申请创建新的资金户',
  curStore: '当前店铺主体',
  businessLicense: '营业执照编号',
  companyName: '公司名称',
  openTips: '将以此资料为您开通新的资金户',
  hasBind: '当前店铺已绑定资金户',
  accBindPhone: '资金户绑定的手机号',
  send: '发送',
  hasRead: '我已阅读并同意Kilimall商家资金户开户协议',
  applyCreate: '申请创建',
  polyOk: '请先同意资金户开户协议!',
  notSend: '请先发送验证码并填写正确的验证码',
  // licenseErr: 'Business license incorrect',

  // dialog bind
  bindTitle: '系统当前限制需绑定到注册公司主体相同的资金户',
  phoneErr: '手机号不正确',
  licenseErr: '资金户编号不正确',
  startBind: '执行绑定',
  complete: '请补齐后四位',
  sameCmp: '同主体的资金户信息',
  notMainBody: '系统暂未查询到同主体的资金户，如您为拥有Kilimall资金户请先行申请创建',
  curMainBody: '当前店铺主体',
  hasBusinessLicenseTips: '营业执照已开过户，请选择绑定操作',
  thisSectionIsTesting: ' 当前功能处于测试期， 数据尚未验证， 以财务结算数据为准',

  // 账单下载
  billK: {
    title: '账单查询',
    billingPeriod: '账单期数',
    billDownload: '账单下载',
    downloadBill: '下载账单',
    bankreceipt: '银行回单',
    bill_text: '注： 如果您对账单有疑问请',
    customerService: '联系客服',
    weChatService: '或详见',
    shopFAQ: '《账单常见问题FAQ》',
    completeInformation: '请联系客服完善账单周期信息',
    pleaseChoose: '请选择账单期数',
    chooseBill: '请选择期数',
    notqueried: '没有查询到当期的账单'
  },

  // 保证金
  margin: {
    storeMargin: '店铺保证金',
    openShopDeposit: '开通店铺保证金帐户',
    activationSuccessful: '开通成功',
    // 以下的文案目前没用到，后续有需要就用，没需要可删除
    rechargeRecord: '充值记录',
    rechargeId: '记录Id',
    rechargeAccount: '充值账户',
    currency: '币种',
    rechargeAmount: '充值金额',
    rechargeTime: '充值时间',
    accountingDate: '到账时间',
    rechargeWay: '充值方式',
    marginCharge: '保证金充值',
    topUpImmediately: '马上充值',
    recharge: '充值',
    wechatRecharge: '微信充值',
    cancelPaid: '取消支付',
    havePaid: '我已支付',
    topUp: '充值',
    topUpTipOne: '1. 保证金充值必须使用商家入驻企业的对公帐户进行转帐或付款，否则会被退回，请充值时注意。',
    topUpTipTwo: '2. 付款时请确认收款对象为“xxxxxxxxxx公司”，避免意外问题和损失'
  },
  fbk: {
    fbkInventoryAppeal: 'FBK库存申诉 (Trial)',
    appealStatus: '申诉状态',
    all: '所有',
    pendingBusinessReview: '待业务审核',
    pendingFinancialReview: '待财务审核',
    pendingSettlement: '待结算',
    rejected: '已拒绝',
    completed: '已完成',
    productAppealSn: '商品申诉单号',
    mallSKUNumber: '商城SKU号',
    wmsSKUNumber: 'WMS SKU号',
    appealTime: '申诉时间',
    today: 'Today',
    yesterday: 'Yesterday',
    last7Days: '7D',
    wtd: 'WTD',
    mtd: 'MTD',
    qtd: 'QTD',
    threeMonth: '3Month',
    ytd: 'YTD',
    exportExcel: '导出',
    newAppeal: '新申诉',
    appealQty: '申诉Qty',
    approvedQty: '核定Qty',
    displayedQty: '现展示Qty',
    disputedUnitPrice: '申诉单价',
    approvedPrice: '核定单价',
    createTime: '生成时间',
    businessReviewTime: '业务审核时间',
    financialReviewTime: '财务审核时间',
    settlementCompletedTime: '结算完成时间',
    status: '状态',
    operation: '操作',
    details: '详情',
    cancel: '取消',
    canceled: '已取消',
    appeal: '申诉',
    newCreateFbkAppeal: '新建商家FBK库存申诉(详情)',
    fbkAppealInfo: '商家FBK库存申诉(详情)',
    productStoreInfo: '商品和店铺信息',
    productName: '商品名称',
    productSpec: '商品规格',
    salesUnitPrice: '销售单价',
    WMSShowFBKQty: 'WMS展示(FBK)库存',
    latestQueryTime: '最新查询时间',
    affiliatedStore: ' 所属店铺',
    appealInfo: '申诉信息',
    appealCurrency: '申诉币种',
    appealExplain: '申诉说明',
    appealMaterialsUpload: '申诉材料上传',
    appealAcceptanceInfo: '申诉受理信息',
    rejectStatement: '驳回说明',
    check: 'Check',
    qty: 'Qty',
    theEditedValuePrice: '编辑值不可大于售价',
    cnEditedValuePriceTip: '编辑值不可大于销售单价的一半',
    appealExplainTips: '申诉说明限制200字符内',
    uploadTipText: '最多允许5个附件，格式限制为 png,jpg,pdf,  单个附件大小不超过2M',
    settlementTime: '结算时间',
    cancelAppeal: '取消申诉',
    submitAppeal: '提交申诉',
    editAppeal: '编辑申诉',
    StoreNo: 'Store#',
    confirmCancel: '确认进行取消操作吗?',
    pleaseEnter: '请输入',
    mustGreaterZero: '必须大于0'
  }
}
